// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"135":"abc363be","213":"81696e6e","440":"92dcf2a0","527":"9de0889e","651":"ac3bfe9d","667":"39f589a7","753":"5cfea686","761":"d3d9f493","918":"dddf993f"}[chunkId] + ".js";
};